import cx from "classnames";
import { capitalize } from "lodash";

import styles from "./styles.module.scss";

const Input = ({
  id,
  className,
  error = false,
  preset = null,
  ...inputProps
}) => {
  const classNames = cx(styles.wrapper, className, {
    [styles.wrapperDisabled]: inputProps.disabled,
    ...(preset
      ? {
          [styles[`wrapper${capitalize(preset)}`]]:
            styles[`wrapper${capitalize(preset)}`]
        }
      : {})
  });

  inputProps["aria-invalid"] = !!error;

  return (
    <div className={classNames}>
      <input
        className={cx(styles.input, {
          ...(preset
            ? {
                [styles[`input${capitalize(preset)}`]]: true
              }
            : {}),
          [styles.error]: error,
          [styles.disabled]: inputProps.disabled
        })}
        id={id}
        {...inputProps}
      />
    </div>
  );
};

export default Input;
